import { useState } from "react";
import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";

import DstButton from "../../../../../components/DstButton/DstButton";
import MultiSelectLiveDropdown from "../../../../../components/MultiSelectLiveDropdown/MultiSelectLiveDropdown";
import Popup from "../../../../../components/Popup/Popup";
import translate from "../../../../../services/Translate";
import { addUsersToProject } from "../../../Project.function";

const AddUsersModal = ({ show, onClose, projectId, language, onSuccess }: any) => {
  const [selectedUsers, setSelectedUsers] = useState<number[]>([]);
  const [loading, setLoading] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);

  const _handleConfirm = () => {
    addUsersToProject(
      projectId,
      selectedUsers,
      setLoading,
      () => {
        setShowSuccessToast(true);
        setSelectedUsers([]);
        onSuccess();
      },
      language
    );
  };

  return (
    <React.Fragment>
      <Popup
        show={show}
        onClose={onClose}
        modalTitle={translate(language, "PAGES.PROJECT.MAIN_INFOS_TAB.ADD_USERS.TITLE")}
      >
        <MultiSelectLiveDropdown
          category={["users"]}
          label={
            selectedUsers.length > 0
              ? `${selectedUsers.length} ${translate(
                  language,
                  "PAGES.PROJECT.MAIN_INFOS_TAB.ADD_USERS.SELECTED_USERS"
                )}`
              : translate(language, "PAGES.PROJECT.MAIN_INFOS_TAB.ADD_USERS.SELECT_USERS")
          }
          language={language}
          onConfirm={(users) => setSelectedUsers(users.map((user: any) => user.value.id))}
          toggleClass="w-100"
        />

        <div className="d-flex justify-content-end gap-2 mt-4">
          <DstButton variant="secondary" value={translate(language, "GLOBAL.CANCEL")} clickFunction={onClose} />
          <DstButton
            value={translate(language, "GLOBAL.ADD")}
            clickFunction={_handleConfirm}
            disabled={selectedUsers.length === 0}
            loading={loading}
          />
        </div>
      </Popup>

      <ToastContainer position="top-end" className="p-3">
        <Toast bg="success" show={showSuccessToast} onClose={() => setShowSuccessToast(false)} delay={2000} autohide>
          <Toast.Body className="text-white">
            {translate(language, "PAGES.PROJECT.MAIN_INFOS_TAB.ADD_USERS.SUCCESS")}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </React.Fragment>
  );
};

export default AddUsersModal;
